module.exports = __webpack_public_path__ + "static/media/arrow-to-left.21b1392c.svg";